import React from "react";
import {
  ArrowLeft, ArrowRight, RotateCw, Home, Star, History,
  Shield, Settings, Printer, HardDrive, Zap
} from "lucide-react";

const BUTTONS = [
  { key: "back", label: "Back", icon: ArrowLeft },
  { key: "fwd", label: "Forward", icon: ArrowRight },
  { key: "refresh", label: "Refresh", icon: RotateCw },
  { key: "home", label: "Home", icon: Home },
  { key: "spacer" },
  { key: "favs", label: "Favorites", icon: Star },
  { key: "history", label: "History", icon: History },
  { key: "spacer" },
  { key: "scanner", label: "Scanner", icon: Shield, led: "green" },
  { key: "turbo", label: "Turbo", icon: Zap, led: "yellow" },
  { key: "spacer" },
  { key: "hdd", label: "My Files", icon: HardDrive },
  { key: "print", label: "Print", icon: Printer },
  { key: "options", label: "Options", icon: Settings },
];

export default function RetroToolbar({ onAction }) {
  return (
    <div
      data-testid="retro-toolbar"
      className="flex items-center gap-0.5 px-1.5 py-1 border-b border-[#808080]"
      style={{
        background: "linear-gradient(to bottom, #FDFCF5 0%, #ECE9D8 60%, #D6D2BB 100%)",
      }}
    >
      {BUTTONS.map((b, i) => {
        if (b.key === "spacer") {
          return <div key={i} className="w-px h-6 mx-1" style={{ background: "linear-gradient(to bottom, transparent, #808080, transparent)" }} />;
        }
        const Icon = b.icon;
        return (
          <button
            key={b.key}
            data-testid={`toolbar-${b.key}`}
            title={b.label}
            onClick={() => onAction?.(b.key)}
            className="toolbar-btn relative"
          >
            <Icon size={15} />
            {b.led === "green" && (
              <span className="absolute bottom-0.5 right-0.5 w-1.5 h-1.5 rounded-full bg-[#32CD32] shadow-[0_0_3px_#39FF14]" />
            )}
            {b.led === "yellow" && (
              <span className="absolute bottom-0.5 right-0.5 w-1.5 h-1.5 rounded-full bg-[#FFEB3B] shadow-[0_0_3px_#FFEB3B]" />
            )}
          </button>
        );
      })}

      {/* Address bar */}
      <div
        className="ml-2 flex items-center gap-1 bevel-in bg-white px-2 py-[2px] flex-1"
        style={{ fontFamily: '"Share Tech Mono", monospace' }}
      >
        <div className="w-4 h-4 rounded-full" style={{
          background: "radial-gradient(circle at 30% 30%, #FFF59D 0%, #FFEB3B 50%, #F9A825 100%)"
        }} />
        <span className="text-[11px] text-[#555]">lemonwire.fm/client/</span>
        <span className="text-[11px] text-[#222] font-bold truncate">peer-network-client</span>
      </div>
      <button className="bevel-btn text-[11px] px-3 py-0.5 ml-1 font-bold">Go</button>
    </div>
  );
}
